<template>
  <v-container >
    <v-layout align-center justify-center text-xs-center>
      <v-flex x12>
        <h1>Error 404!</h1>
        <h2>La página solicitada no existe o se ha borrado</h2>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
    export default {
        name: "NotFound",
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/NotFound.vue